import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Contact, Status } from 'src/app/shared/shared.models';
import { Broker } from '../broker-settings.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogStructureComponent } from '../../../layout/dialog-structure/dialog-structure.component';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatDivider } from '@angular/material/divider';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-broker-settings-dialog',
    templateUrl: './broker-settings-dialog.component.html',
    styleUrls: ['./broker-settings-dialog.component.scss'],
    imports: [DialogStructureComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatSelect, MatOption, MatDivider, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class BrokerSettingsDialogComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  brokerForm: UntypedFormGroup;
  broker: Broker;

  contactsTableSource = new MatTableDataSource();
  displayedContactColumns: string[] = [
    'contactName',
    'contactMail',
    'contactPhone',
    'actions',
  ];

  clonedBroker: Broker = {
    brokerName: null,
    status: null,
    contacts: null,
  };
  contactsForm: UntypedFormGroup;

  status: Status[] = [
    { value: 0, viewValue: 'inactive' },
    { value: 1, viewValue: 'active' },
  ];
  constructor(
    private dialogRef: MatDialogRef<BrokerSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.brokerForm = new UntypedFormGroup({
      status: new UntypedFormControl(null, [Validators.required]),
      brokerName: new UntypedFormControl(null, [Validators.required]),
    });

    if (this.data) {
      this.broker = this.data;

      this.setFormValues(this.data);
      this.getContacts();
    }

    this.contactsForm = new UntypedFormGroup({
      contactName: new UntypedFormControl(null, Validators.required),
      contactMail: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
      ]),
      phoneNumber: new UntypedFormControl(null, Validators.required),
    });
  }

  setFormValues(broker: Broker): void {
    this.brokerForm.patchValue(broker);
  }

  submitEmitter(): void {
    // when broker existing -> update
    if (this.broker) {
      this.broker.contacts = this.contactsTableSource.data as Contact[];
      this.broker = Object.assign(this.broker, this.brokerForm.value);
    } else {
      this.broker = this.brokerForm.value;
      this.broker.contacts = this.contactsTableSource.data as Contact[];
      // add to table
    }

    this.dialogRef.close(this.broker);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  // --- CONTACTS ---
  addContact(): void {
    const c: Contact = {
      contactMail: this.contactsForm.controls.contactMail.value,
      contactPerson: this.contactsForm.controls.contactName.value,
      phoneNumber: this.contactsForm.controls.phoneNumber.value,
    };

    c.id = Math.floor(Math.random() * (500 - 0 + 1)) + 0;
    this.contactsTableSource.data.push(c);

    this.contactsTableSource = new MatTableDataSource(
      this.contactsTableSource.data
    );
    this.contactsTableSource.paginator = this.paginator;
  }

  getContacts(): void {
    if (this.broker.contacts == null) {
      this.broker.contacts = [];
    }

    this.contactsTableSource = new MatTableDataSource(this.broker.contacts);
  }

  deleteContact(index: number): void {
    this.contactsTableSource.data.splice(index,
      1
    );
    this.contactsTableSource = new MatTableDataSource(
      this.contactsTableSource.data
    );
  }

  // check if the contacts table is empty
  contactsValiadtion(): boolean {
    if (this.contactsTableSource.data.length === 0) {
      return false;
    }
    return true;
  }
}
